import React, { Component } from "react";
import { connect } from "react-redux";
import { ls } from "../../locale";
import dayjs from "dayjs";
import { getAgentPath, isIOS, jsonHelper } from "../../helpers";

import { Button, Col, Modal } from "react-bootstrap";
import scrollToElement from "scroll-to-element";
import { history, numberFormatter,
  stringFormatter, isInAppBrowser,
  commonHelpers, paymentHelper,
  logEvent } from "../../helpers";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import StatusBar from "../../components/StatusBar";

// Ducks
import { resourceActions } from "../../state/ducks/resources";
import { bookingActions } from "../../state/ducks/booking";
import { paymentActions } from "../../state/ducks/payment";
import { sessionActions } from "../../state/ducks/session";
import { memberActions } from "../../state/ducks/member";
import { mmbActions } from "../../state/ducks/mmb";

import PaymentOptions from "./PaymentOptions";
import Passengers from "./Passengers";
import Contact from "./Contact";
import LoginWindow from "./LoginWindow";
import RegisterForm from "./RegisterForm";

import "./index.scss";
import { DataCollectionIframe } from "./DataCollectionIframe";
import { PaymentStepupWindow } from "./PaymentStepupWindow";
import { backdropActions } from "../../state/ducks/backdrop";
import Backdrop from "../../components/Backdrop";
import { getLastFlightDate } from "./helper";
import { pushCheckoutEvent } from "../../helpers/dataLayer";
import { HoldBooking } from "./HoldBooking";
import clsx from "clsx";
const ApplePayPNG  = new URL('../../images/apple-pay-white.png', import.meta.url).href

class Checkout extends Component {
  constructor(props) {
    super(props);

    const { state: locationState } = props.location;

    this.lastRefreshedPayment = null;
    // lastAttemptedPayment was used to lock the payment method to the gateway of the previous attempt (removed per request)
    // this.lastAttemptedPayment = null;
    this.loadedFingerprints = [];

    let userData = props.getUserData();
    let isShowLogin = false;

    if (!userData || !userData.loggedIn) {
      isShowLogin = true;
      userData = null;
    }

    this.state = {
      formValid: true,
      message: null,
      isShowMessageBox: false,
      errors: {},
      isShowLogin,
      userData,

      passengers: [],
      contact: { error: {} },

      currencyCode: "OMR",
      paymentMethodCode: "CS",
      paymentConvertionMessage: null,
      amount: 0,
      amountToPay: 0,
      adminFee: 0,
      localDebitBins: [],
      paymentStatus: locationState?.payment,
      isEppEligible: false,
      isHolding: false,
      paymentMethods: [],
      enrollDetail: {},

      isShowInsuranceMessageBox: false,
      insuranceMessage: [],
      isShowHoldingMessageBox: false,
    };
  }

  componentDidMount() {

    // this.lastAttemptedPayment = this.state.paymentStatus?.gateway?.toUpperCase() ?? null;
    this.lastRefreshedPayment = null;

    this.unblockHistory = history.block(() => {
      //return 'Are you sure you want to leave this page?'
      if (!this.props.loadingStatus.loading) {
        const message = ls.t('Common.BlockBackButton.Message')
        const title = ls.t('MessageBox.Title.Warning');

        this.showMessageBox(message, title); // ('Please use the back button on the page below to navigate back.', 'Warning');
      }
      return false;
    });

    this.setupBooking();

    // setup cardinal event
    window.addEventListener("message", this.handleCardinalMessage)
    window.document.addEventListener('TDS_PAYMENT_RESULT', this.handleTdsPaymentResult)
  }

  componentWillUnmount() {
    this.unblockHistory();
    window.removeEventListener("message", this.handleCardinalMessage)
    window.document.removeEventListener('TDS_PAYMENT_RESULT', this.handleTdsPaymentResult)
  }

  componentDidUpdate(prevProps) {
    const currentState = this.props.isShowBackdrop
    if (prevProps.isShowBackdrop !== currentState && !currentState) {
      this.setState({
        enrollDetail: { show: false }
      });
    }
  }

  handleCardinalMessage = event => {

    if (event.origin !== this.ddcOrigin) {
      return;
    }

    const data = JSON.parse(event.data);

    logEvent({
      trackId: data.SessionId,
      eventName: 'cardinal event',
      details: {
        eventData: data
      }
    })

    this.processedCallback(data)
  }

  handleTdsPaymentResult = event => {
    const self = this
    const detail = event.detail

    logEvent({
      eventName: 'tds payment result received',
      details: detail
    })

    setTimeout(() => {

      this.props.showBackdrop(false)

      const state = {
        enrollDetail: {
          show: false
        },
      }

      // detail is null: invalid parameter:
      // detail.code is not null: validation failed
      if(!detail || detail.code) {
        // handle error code
        self.setState({
          paymentStatus: {
            code: "1000",
            reference: detail.reference
          },
          ...state
        })
        return
      }

      self.setState(state)
      // refresh the page
      self.goNext()

    }, 100);
  }

  handleWhatsAppChanged = async checked => {

    const { booking } = this.props;
    if(booking.paymentStarted) return;

    if(booking.bookingMode === 'Booking') {
      const formValues = this.getFormValues();
      if (!formValues) return;

      await this.props.updatePassengers(formValues.passengers, formValues.contact)
      return this.updateWhatsApp(checked);
    }
    else {
      // no need to update passenger info
      return this.updateWhatsApp(checked);
    }
  }

  updateWhatsApp = async checked => {
    if(checked) {
      await this.props.addWhatsApp();
    }
    else {
      await this.props.removeWhatsApp()
    }
    await this.props.getBookingWithSummary();
    await this.refreshPaymentTotal(this.state.paymentMethodCode, true);
  }

  setupFingerPrint = (forceRefresh, eppSelected) => {
    // keep the EPP state of the last fingerprint if not specified
    const lastFingerprint = this.loadedFingerprints[this.loadedFingerprints.length - 1];
    if(eppSelected === undefined) eppSelected = lastFingerprint ? lastFingerprint.epp : false;

    if(!forceRefresh) {
      if(lastFingerprint && lastFingerprint.epp === !!eppSelected) return;
    }

    this.props.getFingerprint(eppSelected).then(response => {
      if(!response.fingerprintUrl) return;

      this.loadedFingerprints.push({url: response.fingerprintUrl, epp: !!eppSelected});

      // fingerprint onload callback
      const onload = () => {
        logEvent({
          trackId: response.reference ?? 'notracking',
          eventName: 'booking fingerprint loaded',
          details: {
            url: response.fingerprintUrl
          }
        })
      }

      // fingerprint onerror callback
      const onerror = (error) => {
        logEvent({
          trackId: response.reference ?? 'notracking',
          eventName: 'booking fingerprint failed',
          details: {
            url: response.fingerprintUrl,
            message: `${error.type}: ${error.message}`,
          }
        })
        // remove the failed fingerprint from the array
        // this.loadedFingerprints = this.loadedFingerprints.filter(f => f.url !== response.fingerprintUrl);
        // try one more time. no more retry because we don't pass onerror again
        // setTimeout(() => {
        //   logEvent({
        //     trackId: response.reference ?? 'notracking',
        //     eventName: 'retry loading fingerprint',
        //     details: {
        //       url: response.fingerprintUrl
        //     }
        //   })
        //   commonHelpers.createScriptTag(response.fingerprintUrl, onload);
        // }, 1000)
      }

      // load the script
      commonHelpers.createScriptIframeTag('cs-fingerprint-iframe', response.fingerprintUrl, onload, onerror);


      // load the script
      commonHelpers.createScriptTag(response.fingerprintUrl, onload, onerror);

    })
  }

  setupPaymentMethods = () => {
    return this.props.getPaymentMethods()
    .then(response => {
      let paymentMethods = response.paymentMethods || [];

      if(!isIOS()) {
        // remove Apple Pay if not in iOS environment
        paymentMethods = paymentMethods.filter(method => method !== 'SPW');
      }

      this.setState({
        paymentMethods,
        localDebitBins: response.localDebitBins || []
      });

      return paymentMethods;
    });
  }

  setupBooking = async () => {
    const countries = await this.props.getCountries();
    const { booking, summary } = await this.props.summaryPnr();

    if (booking.bookingStatus === 'Confirmed' && booking.paymentStatus === "Paid") {
      this.goNext();
      return;
    }

    this.setState({
      currencyCode: booking.currencyCode
    });

    const paxData = this.props.getPassengerData();
    if (paxData && paxData.firstName && paxData.lastName) {
      this.prefillPassengerInfo(booking, paxData, countries);
    }

    await this.props.getAncillaries();

    let methods = await this.setupPaymentMethods();
    if (!Array.isArray(methods) || !methods.length) return;

    methods = methods.filter(x => x !== 'PL' && x !== 'SP'); // remove Pay Later and Smart Pay from the list of default options
    if(!methods.length) return;

    if(this.state.amountToPay > 0) {
      await this.setPaymentMethodState(methods[0])
    }
    else if(booking.voucherApplied) {
      // no amount to pay, most likely the booking is fully paid by voucher,
      // so now we set the payment method to voucher and disable the option
      let paymentMethod = methods.find(x => x === 'VCHR');
      if(!paymentMethod) paymentMethod = methods[0];
      await this.setPaymentMethodState(paymentMethod)
    }
    else {
      await this.setPaymentMethodState(methods[0])
    }

    if (paymentHelper.hasStaffFare(booking)) {
      await this.props.getEmployeeInfo();
    }

    pushCheckoutEvent({summary});
  }

  processedCallback = results => {

    //console.log('processedCallback: ', results)

    // in correspondence with the call showLoading() before calling window.Cardinal.setup("init")
    this.props.hideLoading();
    if (!results.Status) {
      const errors = [{ errorCode: 500, message: "unable to validate the card number." }];
      throw errors;
    }

    return this.props.tdsEnrol(this.paymentDetails, results)
      .then((tdsResponse) => {

        //console.log('tdsResponse: ', tdsResponse)
        logEvent({
          trackId: "notrakcing",
          eventName: 'tds enroll complete',
          details: tdsResponse
        })

        if (!tdsResponse.success) {
          const errors = [{ errorCode: 500, message: "unable to complete processing payment." }];
          if(this.handlePaymentError(errors)) {
            this.setupPaymentMethods().then(() => this.setupFingerPrint(true));
          }
          return
        }

        if (tdsResponse.paymentComplete) {
          this.goNext();
        }
        else if (tdsResponse.require3DS) {
          // scroll to the top of the page to show the 3DS iframe
          window.scrollTo(0, 0);
          this.props.showBackdrop(true);
          this.setState({
            enrollDetail: {
              show: true,
              ...tdsResponse.enrollDetail
            },
          })
        }
        else {
          this.setState({
            paymentStatus: {
              code: "1000",
              reference: ''
            }
          })
          scrollToElement('main-container');
          this.setupPaymentMethods().then(() => this.setupFingerPrint(true));
        }
      })
      .catch((error) => {
        // in correspondence with the call showLoading() before calling window.Cardinal.setup("init")
        this.props.hideLoading();
        if(this.handlePaymentError(error)) {
          this.setupPaymentMethods().then(() => this.setupFingerPrint(true));
        }
      })
  }

  prefillPassengerInfo(booking, paxData, countries) {
    const firstPax = Array.isArray(booking.passengers) && booking.passengers.length > 0 ? booking.passengers[0] : null;
    if (firstPax && !firstPax.firstName && !firstPax.lastName) {

      const searchParams = this.props.getSearchParams()
      // don't populate passenger names if it's a booking for friends
      if(!searchParams || searchParams.fare !== 'discounted') {
        firstPax.firstName = paxData.firstName;
        firstPax.lastName = paxData.lastName;
        firstPax.dateOfBirth = paxData.dateOfBirth;
        firstPax.title = paxData.title;
      }

      const contact = booking.contact;
      if (!contact.mobile) contact.mobile = paxData.mobile;
      if (!contact.email) contact.email = paxData.email;

      if (paxData.country && Array.isArray(countries)) {
        const country = countries.find(c => c.countryCode === paxData.country);
        if (country) {
          contact.address.countryCode = paxData.country;
          contact.address.country = country.countryName;
        }
      }
    }
  }

  setPaymentMethodState = (code, forceRefresh) => {
    this.setState({
      paymentMethodCode: code
    });

    return this.refreshPaymentTotal(code, forceRefresh).then(() => {
      if(code === 'CS' || code === 'MADA') {
        this.setupFingerPrint(false);
      }
    });
  };

  refreshPaymentTotal = (code, forceRefresh) => {

    if(code === this.lastRefreshedPayment && !forceRefresh) {
      return Promise.resolve({
        amount: this.state.amount,
        amountToPay: this.state.amountToPay,
        adminFee: this.state.adminFee,
        paymentConvertionMessage: this.state.paymentConvertionMessage,
        additionalOptions: this.state.additionalOptions,
        isHolding: this.state.isHolding,
      });
    }

    return this.props.getPaymentTotal(code)
    .then((data) => {

      this.lastRefreshedPayment = code;

      let message = null;
      if (data.needsConvertion)
        message = `Payment will be in ${data.convertedTo} ${data.convertedAmount}. ` +
                  `(Conversion rate: 1 ${data.convertedFrom} = ${data.rate.toPrecision(4)} ${data.convertedTo})`;

      const result = {
        amount: data.amount,
        amountToPay: data.amountToPay,
        adminFee: data.adminFee,
        paymentConvertionMessage: message,
        additionalOptions: data.additionalOptions,
        isEppEligible: false, // always set to false when the payment method is changed
        isHolding: data.isHolding,
      };
      this.setState({...result});
      return result;
    });
  }


  continue = () => {

    // prevent double click by remember the last called time
    const now = new Date().getTime();
    if(this.lastCalledTime && now - this.lastCalledTime < 3000) return;
    this.lastCalledTime = now;

    const rError = ls.t('Error')
    const rCheckoutPage = ls.t('CheckoutPage')

    const termsState = this.paymentOptionsComponent.getTermsState()
    if (!termsState) {
      this.showMessageBox(rError.CheckoutTerms); // "You must agree to the terms and conditions to process checkout"
      return;
    }

    const valid = this.validateForm();
    if (!valid) {
      this.showMessageBox(rError.InputError.Desc); //  "Some fields do not match the requirements. Please check."
      return;
    }

    const insurance = this.hasInsuranceAdded();
    if(insurance) {
      // check if there are passengers over 75 years old
      const formValues = this.getFormValues();
      const { ageExceeded, ageBase } = this.hasAgeCriteriaForInsurance(formValues.passengers);
      if (ageExceeded) {
        const message = rCheckoutPage.RemoveInsuranceConfirmation.replace('_A_', ageBase);
        this.showInsuranceMessageBox(insurance, message);
        return;
      }

      // check if the payment is going to be made with Pay Later
      const paymentOption = this.paymentOptionsComponent.getFormValues();
      if(paymentOption.paymentMethodCode === 'PL') {
        this.showInsuranceMessageBox(insurance, rCheckoutPage.RemoveInsuranceConfirmationPL);
        return;
      }
    }

    this.commitCheckout(true);

  };

  commitCheckout = (isCheckHolding = false) => {
    const paymentOption = this.paymentOptionsComponent.getFormValues();
    const formValues = this.getFormValues();

    if (!formValues) return;

    if(isCheckHolding && paymentOption.paymentMethodCode === 'PL') {
      this.showHoldingMessageBox();
      return;
    }

    // skip calling updatePassengers in mmb if payment has started
    const booking = this.props.booking;
    if (booking.paymentStarted || booking.bookingMode !== 'Booking') {
      this.makePayment(paymentOption);
      return;
    }

    // commit passenger info
    this.props.updatePassengers(formValues.passengers, formValues.contact)
      .then(passengerResponse => {

        if (!this.state.isShowLogin || !formValues.contact.registerProfile) return passengerResponse;

        const pax = passengerResponse.passengers[0];
        const contact = passengerResponse.contact;

        const register = {
          userName: contact.email,
          password: formValues.contact.profilePassword,
          title: pax.title,
          firstName: pax.firstName,
          lastName: pax.lastName,
          nationality: contact.address.countryCode,
          dateOfBirth: pax.dateOfBirth,
          mobile: contact.mobile,
          email: contact.email
        }
        return this.props.memberRegister(register);
      })
      .then(() => {
        this.makePayment(paymentOption);
      })
  }

  hasInsuranceAdded = () => {
    const booking = this.props.booking;
    if (!booking
      || booking.bookingMode !== 'Booking'
      || !Array.isArray(booking.segments)
      || !booking.segments.length
      || !Array.isArray(booking.passengers)
      || !booking.passengers.length)
      return false;

    // check if the insurance is added
    const passenger = booking.passengers[0];
    if (!passenger.insurances || !passenger.insurances.length) return false;

    const insurance = jsonHelper.cloneDeep(passenger.insurances[0]);
    for (let i = 1; i < booking.passengers.length; i++) {
      const p = booking.passengers[i];
      if (p && p.insurances && p.insurances.length)
        insurance.amount += p.insurances[0].amount;
    }

    return insurance;
  }

  // this function returns the insurance object if it should be removed;
  // otherwise return false (or null)
  hasAgeCriteriaForInsurance = (passengers) => {
    if (!Array.isArray(passengers)) return false;

    // find the last departure flight
    const booking = this.props.booking;
    const lastFlight = booking.segments[booking.segments.length - 1];
    const departureDate = dayjs(lastFlight.departureDate);

    let ageBase = 75;

    let ageExceeded = false;
    passengers.forEach(p => {
      const dob = dayjs(p.dateOfBirth);
      const diff = departureDate.diff(dob, 'year');
      if (diff >= ageBase) ageExceeded = true;
    })

    return { ageExceeded, ageBase };
  }

  start3DS = (paymentDetails) => {
    this.paymentDetails = paymentDetails;

    this.props.authorizeCS(paymentDetails)
      .then((tokenResponse) => {

        // console.log('authorizeCS: ', tokenResponse)

        // setup data collection iframe
        const cardinalCollectionForm = document.querySelector('#cardinal_collection_form');
        if(cardinalCollectionForm) { // form exists
          logEvent({
            trackId: "notracking",
            eventName: 'data collection form submitted',
            details: {
              authDetail: tokenResponse.nextStepData,
            }
          })

          this.props.showLoading();

          const cardinal_collection_form_input = document.getElementById("cardinal_collection_form_input")
          cardinal_collection_form_input.value = tokenResponse.nextStepData.accessToken

          //console.log('start data collection: ', tokenResponse.nextStepData.deviceDataCollectionUrl)

          cardinalCollectionForm.action = tokenResponse.nextStepData.deviceDataCollectionUrl
          cardinalCollectionForm.submit();

          this.ddcOrigin = new URL(tokenResponse.nextStepData.deviceDataCollectionUrl).origin;

        }
        this.authDetail = tokenResponse.nextStepData
      })
      .catch((errors) => {
        this.handlePaymentError(errors);

      })
      .finally(() => {
        this.props.getBooking();
      });
  }

  // return true if the user can retry the payment; otherwise return false
  handlePaymentError = errors => {

    //console.log('handlePaymentError: ', errors)

    if (!Array.isArray(errors)) return true;

    const rejected = errors.find(x => x.errorCode === 700);
    if(rejected) {
      this.setState({
        paymentStatus: {
          code: "1000",
          reference: ''
        }
      })
      scrollToElement('#main-container');
      return true;
    }

    const paymentError = errors.find(x => x.errorCode === 502);
    if (!paymentError) return true;

    const nextPage = "/payment-error";

    this.unblockHistory();
    history.push("/" + ls.lang + nextPage);
    return false;
  }


  isLocalDebitBins = (cardNumber, gateway) => {
    const debitBins = this.state.localDebitBins;
    if(!Array.isArray(debitBins) || !debitBins.length) return false;
    const bins = debitBins.filter(x => x.paymentMethod === gateway).map(b => b.bin)
    if(!bins.length) return false;

    cardNumber = cardNumber.replace(/\s/g, '');

    const match = bins.find(x => cardNumber.startsWith(x));
    return !!match;
  }

  makePayment = (paymentOption) => {
    this.setState({
      paymentStatus: null
    });

    // make payment
    if (paymentOption.paymentMethodCode === "CS") {

      // check if the card number is in OmanNet bins
      // if(this.isLocalDebitBins(paymentOption.cardNumber, 'ON')) {
      //   const rPayment = ls.t('Payment');
      //   // "This card is locally issued in Oman.
      //   // As per the regulations issued by Central Bank Of Oman,
      //   // you will need to choose OmanNet payment option to process the payment."
      //   const message = rPayment.LocalDebit;
      //   this.showMessageBox(message);
      //   return;
      // }

      // if(booking.bookingMode === 'Booking' &&
      //   (this.lastAttemptedPayment === 'SP' || this.lastAttemptedPayment === 'SPW' || (this.lastAttemptedPayment !== 'CS' && this.isLocalDebitBins(paymentOption.cardNumber, 'SP')))) {

      if (this.isLocalDebitBins(paymentOption.cardNumber, 'SP')) {
        // this.lastAttemptedPayment = "SP";
        return this.processSmartPayPayment(paymentOption);
      }

      // this.lastAttemptedPayment = "CS";
      const expiryFields = paymentOption.expiration.split("/")

      const details = {
        methodCode: "CS",
        cardNumber: paymentOption.cardNumber,
        nameOnCard: paymentOption.nameOnCard,
        expiryYear: expiryFields[1],
        expiryMonth: expiryFields[0],
        cvNumber: paymentOption.cvc,
        eppSelected: this.state.isEppEligible && !!paymentOption.eppSelected
      };
      this.start3DS(details);
      return;
    }

    if(paymentOption.paymentMethodCode === "SPW") {
      // this.lastAttemptedPayment = 'SPW';
      return this.processWalletPayment(paymentOption);
    }

    if (paymentOption.paymentMethodCode === "MADA") {
      return this.processMadaPayment(paymentOption);
    }

    if (paymentOption.paymentMethodCode === "VCHR") {
      return this.processVoucherPayment(paymentOption);
    }

    if (paymentOption.paymentMethodCode === "ON") {
      return this.props.makeOmanDebitPayment()
        .then((onResponse) => {
          // we show the loading mask to prevent the 'Pay Now' button is hit again
          this.props.showLoading();
          window.location.href = onResponse.redirectUrl;
        })
    }

    if(paymentOption.paymentMethodCode === 'KNET') {
      // console.log('pay with KNET.')
      return this.props.getKnetPaymentParams()
        .then(response => {
          if(response.formAction) {
            // console.log(response)
            const data = [...response.paymentFormData]
            const form = paymentHelper.createMadaForm(response.formAction, data)
            this.props.showLoading()
            form.submit()
          }
        })
    }

    if(paymentOption.paymentMethodCode === 'SP') {
      return this.processSmartPayPayment(paymentOption);
    }

    if(paymentOption.paymentMethodCode === 'INVC') {
      return this.props.makeAGPayment().then(() => {
        this.goNext();
      })
    }

    if(paymentOption.paymentMethodCode === 'FT') {
      return this.props.makeFTPayment().then(() => {
        this.goNext();
      })
      .catch(errors => {
        this.handlePaymentError(errors);
      })
    }

    if(paymentOption.paymentMethodCode === 'CASH') {
      const request = {
        refNumber: paymentOption.refNumber
      }
      return this.props.makeCashPayment(request).then(() => {
        this.goNext();
      })
      .catch(errors => {
        this.handlePaymentError(errors);
      })
    }
  };

  checkCardNumberForMadaPayment = cardNumber => {

    if(this.state.paymentMethodCode !== 'CS') return

    if(this.isLocalDebitBins(cardNumber, 'KNET')) {
      this.refreshPaymentTotal('KNET')
    }
    else {
      this.refreshPaymentTotal('CS').then(data => {
        if(data.additionalOptions?.includes('EPP')) {
          this.setState({
            isEppEligible: this.isLocalDebitBins(cardNumber, 'EPP')
          })
        }
      })
    }
  }

  processVoucherPayment = paymentOption => {
    const request = {
      voucherNumber: paymentOption.code,
      pin: paymentOption.pin
    };

    return this.props.makeVoucherPayment(request)
      .then((voucherResponse) => {
        if (voucherResponse.remaining === 0) {
          if(voucherResponse.bookingConfirmed === true) {
            this.goNext();
          }
          else {
            this.paymentOptionsComponent.resetCurrentPayment(true);
            this.props.getBookingWithSummary()
            .then(() => this.refreshPaymentTotal('VCHR', true));
          }
        }
        else {
          this.paymentOptionsComponent.resetCurrentPayment();
          this.setPaymentMethodState("CS")
          .then(() => {
            this.props.getBookingWithSummary();
          });
        }
      })
      .catch((error) => {
        console.log(error)
        this.props.getBooking();
      });
  }

  processSmartPayPayment = paymentOption => {
    const expiryFields = paymentOption.expiration.split("/")

    const details = {
      methodCode: "SP",
      cardNumber: paymentOption.cardNumber,
      nameOnCard: paymentOption.nameOnCard,
      expiryYear: '20' + expiryFields[1],
      expiryMonth: expiryFields[0],
      cvNumber: paymentOption.cvc
    };

    return this.props.getSmartPayMerchantHostedParams(details)
    .then(response => {
      if(response.postUrl && response.formData) {
        // console.log(response)
        const data = [{
          fieldName: 'encRequest',
          fieldValue: response.formData.EncryptedRequest
        },{
          fieldName: 'access_code',
          fieldValue: response.formData.AccessCode
        }]
        const form = paymentHelper.createSmartPayForm(response.postUrl, data)
        this.props.showLoading()
        form.submit()
      }
    })
    .catch(error => {
      this.handlePaymentError(error);
    })
  }

  processWalletPayment = () => {
    return this.props.getWalletPaymentParams()
    .then(response => {
      if(response.postUrl && response.formData) {
        // console.log(response)
        const data = [{
          fieldName: 'encRequest',
          fieldValue: response.formData.EncryptedRequest
        },{
          fieldName: 'access_code',
          fieldValue: response.formData.AccessCode
        }]
        const form = paymentHelper.createSmartPayForm(response.postUrl, data)
        this.props.showLoading()
        form.submit()
      }
    })
    .catch(error => {
      this.handlePaymentError(error);
    })
  }

  processMadaPayment = paymentOption => {
    const expiryFields = paymentOption.expiration.split("/")

    return this.props.getMadaPaymentParams().then(response => {

      if(response.formAction) {
        const data = [...response.paymentFormData]
        data.push({fieldName: 'card_number', fieldValue: paymentOption.cardNumber, includeInForm: true })
        data.push({fieldName: 'expiry_date', fieldValue: `${expiryFields[1]}${expiryFields[0]}`, includeInForm: true })
        data.push({fieldName: 'card_holder_name', fieldValue: paymentOption.nameOnCard, includeInForm: true })
        data.push({fieldName: 'card_security_code', fieldValue: paymentOption.cvc, includeInForm: true })

        const form = paymentHelper.createMadaForm(response.formAction, data)

        this.props.showLoading()

        form.submit()
      }
    })
  }

  goNext = () => {
    const { booking } = this.props;

    let nextPage = `/confirmation`;
    if (booking.bookingMode === "MMB") nextPage = `/mmb/summary`;
    else if (booking.bookingMode === "WCI") nextPage = "/wci/confirmation";

    const url = "/" + ls.lang + getAgentPath() + nextPage;

    this.unblockHistory();
    history.push(url, { from: 'checkout' });

  };

  goBack = () => {
    const booking = this.props.booking;
    if (booking && booking.bookingMode === 'MMB')
      this.jumpTo(`/mmb/summary`);
    else
      this.jumpTo(`/seats`);
  };

  jumpTo = (item) => {
    if (!item || this.props.booking.paymentStarted) return;

    this.unblockHistory();
    history.push("/" + ls.lang + getAgentPath() + item);
  };

  validateForm = () => {
    let isPassengersValid = true;
    let isContactValid = true;
    const booking = this.props.booking;

    if (!booking.paymentStarted) {
      // validate passengers
      if (this.passengersComponent && booking.bookingMode === "Booking") {
        isPassengersValid = this.passengersComponent.validateForm();
      }
    }

    if (this.contactComponent) {
      isContactValid = this.contactComponent.validateForm();
    }

    const isRegistrationFormValid = this.state.isShowLogin && this.registerForm ? this.registerForm.validateForm() : true;

    const isPaymentFormValid = this.state.amountToPay  > 0 ? this.paymentOptionsComponent.validateForm() : true;
    return isPassengersValid && isContactValid && isPaymentFormValid && isRegistrationFormValid;
  };

  getFormValues = () => {
    const result = {
      passengers: [],
      contact: {},
    };

    if (this.passengersComponent)
      result.passengers = this.passengersComponent.getFormValues();
    if (this.contactComponent)
      result.contact = this.contactComponent.getFormValues();
    else
      result.contact = this.props.booking.contact;

    if (this.state.isShowLogin && this.registerForm) {
      const register = this.registerForm.getFormValues();
      if (register.checked) {
        result.contact.registerProfile = true;
        result.contact.profilePassword = register.password;
      }
    }

    return result;
  };

  removeInsurance = () => {
    this.closeInsuranceMessageBox();

    this.props.removeInsurance()
      .then(() => {
        this.commitCheckout(true);
      });
  }

  closeMessageBox = () => {
    this.setState({
      isShowMessageBox: false,
      message: null
    });
  };

  showMessageBox = (message, title) => {
    this.setState({
      isShowMessageBox: true,
      message: message,
      messageTitle: title
    });
  };

  showLoginWindow = () => {
    this.loginWindow.show();
  }

  showInsuranceMessageBox = (insurance, message) => {
    if (!insurance) return;

    const bookingSummary = this.props.bookingSummary;
    const insuranceRemovedTotal = numberFormatter.formatCurrency(bookingSummary.bookingTotal - bookingSummary.paidTotal - insurance.amount);
    const insConfirmation = message
      ? stringFormatter.formatString(message, `${this.state.currencyCode} ${insuranceRemovedTotal}`).split(/[\r|\n]/)
      : [];

    this.setState({
      isShowInsuranceMessageBox: true,
      insuranceMessage: insConfirmation,
    })
  }

  closeInsuranceMessageBox = () => {
    this.setState({
      isShowInsuranceMessageBox: false,
      insuranceMessage: [],
    })
  }

  showHoldingMessageBox = () => {
    this.setState({
      isShowHoldingMessageBox: true,
    })
  }

  closeHoldingMessageBox = () => {
    this.setState({
      isShowHoldingMessageBox: false,
    })
  }

  login = (username, password) => {
    this.loginWindow.hide();
    this.props.memberLogin(username, password).then(() => {
      this.setState({
        isShowLogin: false,
      });

      this.props.getProfile();
      const formValues = this.getFormValues();
      if(!hasPrefilledValues(formValues)) {
        this.props.populateBooking();
      }
    });
  }

  resetPassword = username => {
    this.loginWindow.hide();
    this.props.forgotPassword(username).then(() => {
      this.showMessageBox('Your new password has been sent to your contact email. Please check your mailbox.', 'Notification');
    })
  }

  handlePaymentStepupFormSubmit = data => {
    logEvent({
      trackId: data.SessionId ?? "notracking",
      eventName: 'stepup form submitted',
      details: data
    })
  }

  handlePaymentStepupFormError = (message, data) => {
    logEvent({
      trackId: data.SessionId ?? "notracking",
      eventName: 'stepup form error',
      details: {
        error: message,
        data
      }
    })
  }

  handleHoldBookingChange = (holding) => {
    if(holding) {
      this.showHoldingMessageBox();
      return
    }

    this.props.unHoldBooking().then(() => {
      // refresh payment methods
      this.setupPaymentMethods().then(methods => {
        if (!Array.isArray(methods) || !methods.length) return;
        methods = methods.filter(x => x !== 'PL' && x !== 'SP');
        if(!methods.length) return;
        this.setPaymentMethodState(methods[0], true)
      });
    })
  }

  doHoldBooking = () => {
    this.props.holdBooking().then(() => {
      // refresh payment methods
      this.setupPaymentMethods().then(methods => {
        if (!Array.isArray(methods) || !methods.length) return;
        methods = methods.filter(x => x !== 'PL' && x !== 'SP');
        if(!methods.length) return;
        this.setPaymentMethodState(methods[0], true)
      });
    })
  }

  render() {

    const rCheckoutPage = ls.t('CheckoutPage');
    if (!rCheckoutPage.TotalDue) return null;

    const rButton = ls.t('Button');
    const rMessageBox = ls.t('MessageBox');
    const rError = ls.t('Error');
    const rPayment = ls.t('Payment');

    const { countries, booking, bookingSummary } = this.props;
    const passengers = (booking && booking.passengers) || [];
    const contact = (booking && booking.contact) || {};

    let flightDate = getLastFlightDate(booking);
    if (!flightDate) flightDate = new Date();

    const paymentStatus = this.state.paymentStatus;
    const paymentStarted = booking.paymentStarted;

    const inAppBrowser = isInAppBrowser();

    const employeeInfo = this.props.employeeInfo || {};

    const inBookingMode =
      !booking || booking.bookingMode === "Booking";

    const amount = this.state.amount + bookingSummary.paidTotal - this.state.adminFee
    const splittedAmount = numberFormatter.decimalSplitter(numberFormatter.formatCurrency(amount));
    const splittedPaidTotal = numberFormatter.decimalSplitter(bookingSummary.paidTotal);
    const splittedAmountToPay = numberFormatter.decimalSplitter(numberFormatter.formatCurrency(this.state.amountToPay));
    const splittedAdminFee = numberFormatter.decimalSplitter(this.state.adminFee);

    const userData = this.state.userData;

    const isStaffFare = paymentHelper.hasStaffFare(booking)

    const terms = `<a href="${rPayment.Links.TermsAndConditions}" target="_blank">${rPayment.TermsConditions}</a>`;
    const usage = `<a href="${rPayment.Links.UsagePolicy}" target="_blank">${rPayment.UsagePolicy}</a>`;
    const baggage = `<a href="${rPayment.Links.BaggagePolicy}" target="_blank">${rPayment.BaggagePolicy}</a>`;
    const carriage = `<a href="${rPayment.Links.CarriageConditions}" target="_blank">${rPayment.CarriageConditions}</a>`
    const statement = `${stringFormatter.formatString(rPayment.Statement, terms, usage, baggage, carriage)}`;

    const isShowPaymentDenied = paymentStatus && (paymentStatus.code === "1000" || paymentStatus.code === '1001')
    const holdingMessage = this.state.isShowHoldingMessageBox ? rCheckoutPage.HoldBooking.Message.split(/[\r|\n]/) : [];

    const ancillaries = this.props.ancillaries || [];
    const holdingFee = findHoldingFee(ancillaries);

    return (
      <div id="main-container"
        className={!inAppBrowser
          ? ls.t("rootClass") + " main-container checkout-page "
          : ls.t("rootClass") + " main-container checkout-page in-mobile-app"}
        dir={ls.t("direction")}>
        <div className="header-con">
          <Header key={commonHelpers.getHashCode(bookingSummary, this.state.isShowLogin)}
            hasSummary={true}
            beforeChangeLocation={() => this.unblockHistory()}
          />
        </div>
        <Backdrop />
        {!inAppBrowser && <StatusBar label="checkout" onItemClick={(item) => this.jumpTo('/' + item)} />}
        <div className="container passenger padt40 padb40">
          <div className="min-height">
            <input type="hidden" value="salamair" />
            {isShowPaymentDenied && <PaymentDeniedMessage message={rError.PaymentDeclined} />}

            {!paymentStarted && inBookingMode && <Passengers
              ref={(element) => (this.passengersComponent = element)}
              key={commonHelpers.getHashCode(passengers, employeeInfo)}
              passengers={passengers}
              flightDate={flightDate}
              isShowLogin={this.state.isShowLogin}
              onLogin={this.showLoginWindow}
              employeeInfo={employeeInfo}
              isStaffFare={isStaffFare}
              userData={userData}
              ancillaries={ancillaries}
              currencyCode={booking && booking.currencyCode}
              hasInsurance={this.hasInsuranceAdded()}
            />
            }
            {/* hide contact in mmb */}
            {inBookingMode && <Contact
              ref={(element) => (this.contactComponent = element)}
              key={commonHelpers.getHashCode(contact, employeeInfo)}
              contact={contact}
              countries={countries}
              employeeInfo={employeeInfo}
              passengers={passengers}
              ancillaries={ancillaries}
              currencyCode={booking.currencyCode}
              onWhatsAppChanged={this.handleWhatsAppChanged}
            // readOnly={booking && booking.modified}
            />}

            {booking?.bookingMode === 'Booking' && this.state.isShowLogin && <RegisterForm
              ref={element => (this.registerForm = element)} />}

            {rCheckoutPage.BaggagePolicy &&<div className="tw-my-4" dangerouslySetInnerHTML={{__html: rCheckoutPage.BaggagePolicy}} />}

            {this.state.paymentMethods?.includes('PL') && holdingFee?.amount && <HoldBooking
              holding={this.state.isHolding}
              price={holdingFee.amount}
              currencyCode={booking.currencyCode}
              onChange={this.handleHoldBookingChange}
              disabled={paymentStarted}
            />}

            <PaymentOptions
              ref={(element) => (this.paymentOptionsComponent = element)}
              userData={userData}
              statement={statement}
              paymentMethods={this.state.paymentMethods}
              paymentMethodCode={this.state.paymentMethodCode}
              paymentStatus={this.state.paymentStatus}
              voucherApplied={booking.voucherApplied}
              onPaymentMethodChanged={(method) => this.setPaymentMethodState(method)}
              onApplyVoucher={this.continue}
              onCreditCardNumberChange={this.checkCardNumberForMadaPayment}
              localDebitBins={this.state.localDebitBins}
              disabled={this.state.amountToPay === 0}
              eppEligible={this.state.isEppEligible}
              onEppSelectionChange={eppSelected => this.setupFingerPrint(false, eppSelected)}
              // lastAttemptedPayment={this.lastAttemptedPayment}
            />

            <Col xs={12} md={8} mdOffset={4}>
              <div className="final-amount center-block">
                <h4>{rCheckoutPage.TotalDue}</h4>
                {!inBookingMode && <p>
                  <span>{rCheckoutPage.Charge}</span>
                  <span className="price">
                    {this.state.currencyCode}
                    <span>{splittedAmount.amount}
                      <span className="decimal-point">
                        {numberFormatter.oneDecimalPoint(splittedAmount.decimal, 'OMR')}
                      </span>
                    </span>
                  </span>
                </p>}
                {inBookingMode && <p>
                  <span>{ this.state.isHolding ? rCheckoutPage.HoldBooking.Fee : rCheckoutPage.TicketPrice}</span>
                  <span className={"price" + ( this.state.amountToPay === 0 ? " strike-price" : '')}>
                    {this.state.currencyCode}
                    <span>{splittedAmount.amount}
                      <span className="decimal-point">
                        {numberFormatter.oneDecimalPoint(splittedAmount.decimal, 'OMR')}
                      </span>
                    </span>
                  </span>
                </p>}
                {
                  this.state.adminFee > 0 && (
                    <p>
                      <span>{rCheckoutPage.AdminFee}</span>
                      <span className="price">
                        {this.state.currencyCode}
                        <span>{splittedAdminFee.amount}</span>
                        <span className="decimal-point">
                          {numberFormatter.oneDecimalPoint(splittedAdminFee.decimal, 'OMR')}
                        </span>
                      </span>
                    </p>
                  )
                }
                {
                  //paid by voucher
                  this.props.bookingSummary.paidTotal > 0 && (
                  <p>
                    <span>{rCheckoutPage.PaidByVoucher}</span>
                    <span className="price">
                      {this.state.currencyCode}
                      <span>{splittedPaidTotal.amount}
                        <span className="decimal-point">
                          {numberFormatter.oneDecimalPoint(splittedPaidTotal.decimal, 'OMR')}
                        </span>
                      </span>
                    </span>
                  </p>
                )}

                <p className="total">
                  <span>{rCheckoutPage.TotalToPay}</span>
                  <span className="price">
                    {this.state.currencyCode}
                    <span>
                      {splittedAmountToPay.amount}
                      <span className="decimal-point">
                        {numberFormatter.oneDecimalPoint(splittedAmountToPay.decimal, 'OMR')}
                      </span>
                    </span>
                  </span>
                </p>
                {this.state.paymentConvertionMessage && (
                  <span className="conversion-rate">
                    {this.state.paymentConvertionMessage}
                  </span>
                )}
              </div>
            </Col>
            <div className="clearfix btnCon col-xs-12">
              {!this.props.booking.paymentStarted && !inAppBrowser && <Button
                className="btn btn-primary btn-cancel btn-effect"
                onClick={() => this.goBack()}>
                <span>
                  <i className="picon picon-btn-arrow-left-w" /> {rButton.Back}
                </span>
              </Button>}
              <div className="pull-right flip">
                <Button
                  className={clsx("btn btn-submit pull-right flip btn-effect",
                    this.state.paymentMethodCode === 'SPW' ? 'btn-submit-black btn-effect-black' : '',
                  )}
                  onClick={() => this.continue()}
                >
                  <span className="tw-flex tw-items-center tw-justify-center tw-gap-1">
                    {this.state.amountToPay <= 0 ? rButton.Confirm : (this.state.paymentMethodCode === 'SPW' ? rButton.PayWith : rButton.PayNow) }
                    {this.state.paymentMethodCode === 'SPW' ? <img src={ApplePayPNG} alt="Apple Pay" height={18} /> : <i className="picon picon-btn-arrow-right-w" />}
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </div>
        {!inAppBrowser && <Footer />}
        <Modal className={ls.t("rootClass")}
          show={this.state.isShowMessageBox && !this.props.loadingStatus.loading}
          onHide={this.closeMessageBox} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>{this.state.messageTitle || rMessageBox.InputError}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>{this.state.message}</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeMessageBox}>{rButton.Close}</Button>
          </Modal.Footer>
        </Modal>
        <Modal className={ls.t('rootClass')}
          show={this.state.isShowInsuranceMessageBox && !this.props.loadingStatus.loading}
          onHide={this.closeInsuranceMessageBox} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>{'Confirmation'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.insuranceMessage.map((c, index) => (<p key={index}>{c}</p>))}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeInsuranceMessageBox}>{rButton.Cancel}</Button>
            <Button onClick={this.removeInsurance}>{rButton.Continue}</Button>
          </Modal.Footer>
        </Modal>
        <Modal className={ls.t('rootClass')}
          show={this.state.isShowHoldingMessageBox && !this.props.loadingStatus.loading}
          onHide={this.closeHoldingMessageBox} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>{'Confirmation'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {holdingMessage.map((c, index) => (<p key={index}>{c}</p>))}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeHoldingMessageBox}>{rButton.Cancel}</Button>
            <Button onClick={() => {this.closeHoldingMessageBox(); this.doHoldBooking();}}>{rButton.Continue}</Button>
          </Modal.Footer>
        </Modal>
        <LoginWindow ref={node => this.loginWindow = node} onLogin={this.login}
          onResetPassword={this.resetPassword} />
        <DataCollectionIframe />
        {this.state.enrollDetail.show && <PaymentStepupWindow
          md={this.state.enrollDetail.md}
          jwt={this.state.enrollDetail.accessToken}
          stepUpUrl={this.state.enrollDetail.stepUpUrl}
          windowHeight={this.state.enrollDetail.windowHeight}
          windowWidth={this.state.enrollDetail.windowWidth}
          onSubmit={this.handlePaymentStepupFormSubmit}
          onError={this.handlePaymentStepupFormError}
        />}
      </div>
    );
  }
}

const PaymentDeniedMessage = (props) => {

  let message = props.message || '';
  message = message.split(/[\r\n]/);

  return (
    <div className="alert alert-danger">
      {message.map((m, index) => <p key={index}>{m}</p>)}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    countries: state.resources.countries,
    booking: state.booking.details,
    bookingSummary: state.booking.summary,
    loadingStatus: state.redux.loadingStatus,
    employeeInfo: state.member.employeeInfo,
    ancillaries: state.booking.ancillaries,
    isShowBackdrop: state.backdrop.show
  };
}

const mapDispatchToProps = {
  ...bookingActions,
  ...paymentActions,
  ...resourceActions,
  ...backdropActions,
  getUserData: sessionActions.getUserData,
  getPassengerData: sessionActions.getPassengerData,
  getSearchParams: sessionActions.getSearchParams,
  showLoading: sessionActions.showLoading,
  hideLoading: sessionActions.hideLoading,
  memberLogin: memberActions.memberLogin,
  getProfile: memberActions.getProfile,
  forgotPassword: memberActions.forgotPassword,
  memberRegister: memberActions.memberRegister,
  getEmployeeInfo: memberActions.getEmployeeInfo,
  resetBooking: mmbActions.resetBooking,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Checkout);

function findHoldingFee(ancillaries) {
  if (!Array.isArray(ancillaries) || !ancillaries.length) return 0;

  // use for loop to iterate through the ancillaries to find the holding fee
  // the holding fee is in the holdingFees array of a passenger
  for (const anci of ancillaries) {
    if (!Array.isArray(anci.passengers) || !anci.passengers.length) continue;
    const pax = anci.passengers.find(p => p.holdingFees?.length > 0);
    if (!pax) continue;

    return pax.holdingFees[0];
  }

  return null
}


function hasPrefilledValues(formValues) {
  if (!formValues) return false;

  const isEmpty = commonHelpers.isEmpty;

  // check if it has prefilled passenger
  if(Array.isArray(formValues.passengers)) {
    const hasPrefilled = formValues.passengers.find(p => !isEmpty(p.firstName) && !isEmpty(p.lastName));
    if (hasPrefilled) return true;
  }
  // check if it has prefilled contact
  if(!isEmpty(formValues.contact?.mobile) || !isEmpty(formValues.contact?.email)) {
    return true;
  }

  return false;
}